import { TUserItem, TUserSelfInvitationItem } from "@/data/types";
import { State } from "../state/state";

export const getAllUsers = (state: State): TUserItem[] => state.users.items;

export const getUserInvitations = (state: State): TUserSelfInvitationItem[] => state.users.invitations;

export const getCurrentUser = (state: State): TUserItem | null =>
  state.users.currrentUser;
